module.exports = __webpack_public_path__ + "static/img/image_solutions_optics_09.0c82bc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_optics_09.png
// module id = G972
// module chunks = 10